import { Component, computed, input } from '@angular/core';

@Component({
    selector: 'message-timestamp',
    templateUrl: './message-timestamp.component.html',
    standalone: false
})
export class MessageTimestampComponent {
    public occurredAtTimestamp = input<number>();
    public fromClient = input<boolean>(false);

    public formattedTime = computed(() => {
        const timestampMs = this.occurredAtTimestamp() / 1000;
        const date = new Date(timestampMs);

        return date.toLocaleString('nl-NL', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
            timeZone: 'Europe/Amsterdam'
        });
    });
}
